import React from 'react';
import { ConnectedPersonalSpace } from './ConnectedPersonalSpace';
import { PersonalSpaceOwnProps } from './PersonalSpace';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { ConnectedQueryParamUpdateProvider } from '../RouterHelpers/QueryParamUpdateProvider';

export interface PersonalSpaceProviderProps extends PersonalSpaceOwnProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
}

const PersonalSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'personal',
  subspaceName: undefined
};

export const PersonalSpaceProvider: React.FunctionComponent<PersonalSpaceProviderProps> = (props) => {
  return (
    <ConnectedSpaceInfoProvider spaceInfo={PersonalSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={false}
        shouldUpdateContentTypes={true}
        shouldUpdateFilters={true}
        shouldUpdateSort={true}
      >
        <ConnectedPersonalSpace
          angularContext={props.angularContext}
        />
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};
